import { render, staticRenderFns } from "./CardChallenges.vue?vue&type=template&id=011d885f"
import script from "./CardChallenges.vue?vue&type=script&lang=js"
export * from "./CardChallenges.vue?vue&type=script&lang=js"
import style0 from "./CardChallenges.vue?vue&type=style&index=0&id=011d885f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports